import getClassNames from './util/get-class-names';
import getDecimal from './util/get-decimal';

export { getClassNames, getDecimal };

export default {
    getClassNames: getClassNames,
    getDecimal: getDecimal
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/